<template>
    <div
      class="modal right fade trader-info"
      id="trader-info"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"       
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" >{{account.account}} - NOTE HISTORY</h5>
            <button type="button" class="close"  @click="$emit('close')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="modal-body">
              <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover bidtbl">
                <thead class="thead-light psticky">
                  <tr>
                    <!-- <th scope="col"  class="sort text-center">ACCOUNT</th> -->
                    <th scope="col"  class="sort text-center">EDITED AT </th>
                    <th scope="col"  class="sort text-center">EDITED BY</th>
                    <th scope="col"  class="sort text-center">NOTE </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="noteHistory.length == 0 && !loading">
                      <td><p class="nodata">No data available</p>
                      </td>
                  </tr>
                  <tr v-for="data in noteHistory" :key="data.AccountId">
                    <!-- <td class="text-center text-primary p-0">{{data.Account}}</td> -->
                    <td class="text-center">{{moment(data.EditedAt).format("MM/DD/YYYY, h:mm:ss a") }}</td>
                    <td class="text-center">{{data.EditedByFirstName }} {{data.EditedByLastName }}</td>
                    <td class="text-center text-wrap">{{data.Note}}</td>

                  </tr>
                </tbody>
              </table>
              <!-- Pagination-->
              <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getNoteHistory(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import authService from "@/authService";
  import config from "@/config";

  export default {
      name: 'notehistory',
      components :{
          
      },
      props: ['account'],
      data() {
          return {
              loading : false,
              noteHistory : [],
              currentPage: 1,
              perPage: 5,
              totalRows : 0,
          };
      },
      methods: { 
        getNoteHistory(){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlBidSide +
                "/account/notes-list?page="+(this.currentPage-1)+"&size="+this.perPage+"&id="+this.account.id,
                auth
            )
            .then(result => {
              this.noteHistory = result.data.content;
              this.totalRows = result.data.totalElements;
              this.loading = false;
            })
          },
      },
      created(){
        this.getNoteHistory()
      }
  };
  </script>